import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { accounts } from "../../utils/appConstants";
import api from "../../utils/api";

const AddAccountBalance = () => {
	const [data, setData] = useState({ account: "", value: "", date_edited: "" });

	const navigate = useNavigate();

	useEffect(() => {}, []);

	const handleChange = (e) => {
		setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
		console.log(data);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {
			await api.post(`/money`, data);
			navigate("/accountBalance");
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<section className="lavella page add-account-balance">
			<div className="container--sm">
				<h3>Add Account Balance</h3>
				<div className="form">
					<div className="field">
						<label>Account</label>
						<select onChange={handleChange} name="account">
							<option value="">Select an account</option>
							{accounts.map((account) => (
								<option value={account.account}>{account.account}</option>
							))}
						</select>
					</div>
					<div className="field">
						<label>Value</label>
						<input type="number" placeholder="$0.00" onChange={handleChange} name="value" />
					</div>
					<div className="field submit">
						<div className="l-btn" onClick={handleSubmit}>
							Add
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default AddAccountBalance;
